const processNewsletterAttrs = ( newsletterAttrs ) => {
  const apiSettings = {};

  // eslint-disable-next-line no-unused-vars
  Object.entries( [ newsletterAttrs ] ).map( ( [ key, value ] ) => {
    for ( const [ k, v ] of Object.entries( value ) ) {
      if ( k.endsWith( 'Api' ) && v !== '' ) {
        const cleanUpKey = k.split( 'Api' )[0];
        apiSettings[cleanUpKey] = v;
      }
    }
    return apiSettings;
  });

  return createInputFields( apiSettings );
};

const createInputFields = ( settings ) => {
  const inputFields = Object.entries( settings ).map( ( [ key, value ], index ) => {
    return (
      <input key={ index } type="hidden" name={ key } value={ value.toString() } />
    );
  });

  return inputFields;
};

export { processNewsletterAttrs };
